import type { BuyerOption, OptionStateMap } from '@openx/types/options.ts';
import { useMemo } from 'react';
import { useOptionsByPathQuery } from '../../../hooks/useOptionsByPathQuery.ts';

export const useDspSeatsFetch = (demandPartnerId): OptionStateMap<BuyerOption> => {
  const { data: { optionsByPath = [] } = {}, loading } = useOptionsByPathQuery({
    skip: !demandPartnerId,
    variables: {
      filter: {
        demand_partner_id: demandPartnerId,
      },
      path: 'deal.deal_participants.buyer_ids',
    },
  });

  const buyersMap = useMemo(
    () =>
      optionsByPath.reduce((acc, option) => {
        if (!option) return acc;

        const { id, name, extra: { third_party_buyer_id = undefined } = {} } = option;

        if (third_party_buyer_id?.length > 0) {
          third_party_buyer_id.forEach(seatId => {
            acc[seatId] = {
              buyer_id: id,
              id: seatId,
              name: `${name} > ${seatId}`,
              seat_id: seatId,
            };
          });
        } else {
          acc[id] = { buyer_id: id, id: id, name: name };
        }

        return acc;
      }, {}),
    [optionsByPath]
  );

  return { loading, mapById: buyersMap ?? {} };
};
